/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { RecipientListContainer as RecipientList } from './RecipientList.container';
export * from './Recipient';
